module.exports = __webpack_public_path__ + "img/type--1-spans--single-lang--de.f25ea502.jpg";